export const DEFAULT_RECYCLING_TARGET = 80;

export enum ViewType {
  BUILDING = "BUILDING",
  PORTFOLIO = "PORTFOLIO",
}
